import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  animation: fadeIn 0.5s ease-in;

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

export const HeaderFlex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  border-bottom: 1px solid #333;
  padding-bottom: 15px;

  .btn-save-fixed {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #ef4444;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: bold;
    cursor: pointer;
    transition: 0.3s;
    &:hover { background: #dc2626; transform: scale(1.05); }
    &:disabled { background: #555; cursor: not-allowed; }
  }
`;

export const ConfigGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 20px;

  .full-card { grid-column: 1 / -1; }
`;

export const Card = styled.div`
  background: #1a1a1a;
  border-radius: 12px;
  border: 1px solid #333;
  overflow: hidden;

  .card-header {
    background: #222;
    padding: 15px;
    display: flex;
    align-items: center;
    gap: 10px;
    border-bottom: 1px solid #333;
    h3 { font-size: 16px; margin: 0; color: #fff; }
    .icon-red { color: #ef4444; }
  }

  .card-body {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  label { font-size: 13px; color: #aaa; font-weight: 500; }
  
  input, select {
    background: #0f0f0f;
    border: 1px solid #333;
    color: #fff;
    padding: 10px;
    border-radius: 6px;
    outline: none;
    transition: 0.3s;
    &:focus { border-color: #ef4444; box-shadow: 0 0 5px rgba(239, 68, 68, 0.3); }
  }

  .input-readonly { background: #222; color: #666; cursor: not-allowed; }
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  margin-bottom: 10px;

  label {
    margin: 0 !important;
    font-size: 14px;
    font-weight: 500;
    color: #e0e0e0;
    cursor: pointer;
  }
`;

export const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 46px;
  height: 24px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #333;
    transition: .4s;
    border-radius: 24px;
    border: 1px solid #444;

    &:before {
      position: absolute;
      content: "";
      height: 16px;
      width: 16px;
      left: 4px;
      bottom: 3px;
      background-color: white;
      transition: .4s;
      border-radius: 50%;
      box-shadow: 0 0 10px rgba(0,0,0,0.5);
    }
  }

  input:checked + .slider {
    background-color: #ef4444;
    border-color: #ff5f5f;
    box-shadow: 0 0 8px rgba(239, 68, 68, 0.4);
  }

  input:checked + .slider:before {
    transform: translateX(20px);
  }
`;

export const FileUploadLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background: #222;
  border: 2px dashed #444;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.3s;
  color: #ccc;
  justify-content: center;
  &:hover { border-color: #ef4444; color: #fff; background: #2a2a2a; }
`;